/**
 * Get the server URI dynamically based on the current window location
 * This allows the app to work with any domain (cito.appclever.pl, cito.rdbm.pl, etc.)
 * Falls back to environment variable if window is not available (SSR/build time)
 * 
 * In development mode, if client is on port 3000, server is expected on port 4000
 */
export const getServerUri = () => {
  if (typeof window !== 'undefined') {
    const isDevelopment = process.env.NODE_ENV === 'development'
    const currentPort = window.location.port
    
    // In development, if client is on port 3000, use port 4000 for server
    if (isDevelopment && currentPort === '3000') {
      return `${window.location.protocol}//${window.location.hostname}:4000`
    }
    
    // Use current domain dynamically - works with any domain (production)
    return `${window.location.protocol}//${window.location.host}`
  }
  // Fallback for SSR or build time
  return process.env[`REACT_APP_SERVER_URI_${process.env.NODE_ENV}`] || 'http://localhost:4000'
}

